import { render, staticRenderFns } from "./NodeTypeContent.vue?vue&type=template&id=7c635d5e&scoped=true"
import script from "./NodeTypeContent.vue?vue&type=script&lang=js"
export * from "./NodeTypeContent.vue?vue&type=script&lang=js"
import style0 from "./NodeTypeContent.vue?vue&type=style&index=0&id=7c635d5e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c635d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c635d5e')) {
      api.createRecord('7c635d5e', component.options)
    } else {
      api.reload('7c635d5e', component.options)
    }
    module.hot.accept("./NodeTypeContent.vue?vue&type=template&id=7c635d5e&scoped=true", function () {
      api.rerender('7c635d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/NodeTypeContent.vue"
export default component.exports